export default __webpack_public_path__ + "static/media/group-7570.59cf15a1.svg";